export default "__VITE_ASSET__b7ebf334__"